global.BAWE = {
    // dry-run marker:
    branch: 'bawe',
    dry: true,
    o_possible: true,
    type: 'bawe',

    canCalc: function(e) {
	BC.debug('BAWE.canCalc(): Checking ...', '', 64);
	PRIV.calcable = BAWE.haveRisk() && BAWE.havePeril();
	return PRIV.calcable;
    },

    change: function(e) {
	BC.debug('BAWE.change()', '...starting...', 64);
	if (! BAWE.canCalc(e)) {
	    ALL.chgProduct(BAWE.branch, null);
	    ALL.notifyHeight();
	    return;
	}
	BAWE.haveInfo();
	BAWE.recalc();
	ALL.notifyHeight();
    },

    haveInfo: function(e) {
	BAWE.o_possible = Boolean(JQ('#f_' + BAWE.type + '_plz').val() &&
				  JQ('#f_' + BAWE.type + '_ort').val() &&
				  JQ('#f_' + BAWE.type + '_str').val());
	JQ('#b_' +  BAWE.type + '_go2datavn').button("option", "disabled", ! BAWE.o_possible);
	BAWE.o_possible ? JQ('#a_' + BAWE.type + '_da').show() : JQ('#a_' + BAWE.type + '_da').hide();
	BC.debug('BAWE.haveInfo() => ', BAWE.o_possible , 64);
	ALL.notifyHeight();
	return BAWE.o_possible;
    },

    havePeril: function() {
	BC.debug('BAWE.havePeril(): Checking ...', '', 128);
	var valid = false;
	PRIV.bparts['bawe'] = [];
	JQ.each(['bl', 'bh'], function(i, v) {
	    if (JQ("#f_bawe_" + v).is(':checked')) {
		JQ('#div_bawe_' + v + '_1').show();
		PRIV.bparts['bawe'].push(v);
	    } else {
		JQ('#f_bawe_net2_' + v).text('0,00 €');
		JQ('#div_bawe_' + v + '_1').hide();
	    }
	});
	var bl_vs = parseInt(JQ('#f_bawe_bl_vs').val());
	var bh_vs = parseInt(JQ('#f_bawe_bh_vs').val());
	if (JQ("#f_bawe_bl").is(':checked') && bl_vs) {
	    // Bauleistung: Alle Angaben vorhanden
	    valid = true;
	}
	if (! valid && JQ("#f_bawe_bh").is(':checked') && bh_vs) {
	    // Bauherrenhaftpflicht: Alle Angaben vorhanden
	    valid = true;
	}
	ALL.notifyHeight();
	return valid;
    },

    haveRisk: function() {
	BC.debug('BAWE.haveRisk(): Checking ...', '', 64);
	// valid = true : Alle Risikomerkmale vorhanden
	var valid = true;
	return valid;
    },

    init: function() {
	BC.debug('BAWE.init():', '', 64);
	PRIV.hideLogoutAndAdministration();
    },

    recalc: function(e) {
	BC.debug('BAWE.recalc():', [], 256);
	if (! BAWE.canCalc()) {
	    BC.debug('BAWE.recalc():', 'Cannot calc - check logs!', 16);
	    return;
	}
	var sa = PRIV.make_sa('bawe');
	BC.debug('BAWE.recalc():', sa, 64);
	JQ.getJSON(JSONURI, sa, BAWE.setPremium);
	ALL.chkContactData();
	ALL.notifyHeight();
    },

    setPremium: function(data) {
	BC.debug('BAWE.setPremium():', data, 64);
 	ALL.chkError(data);
	if (data.ERROR) {
	    return;
	}
	JQ.each(data, function(key, val) {
	    if (key == 'DirA' && val && val.length) {
		PRIV.setDirAnfrage(val);
		return;
	    } else if (JQ('#f_bawe_' + key).length) {
		JQ("#f_bawe_" + key).text(val.str);
	    }
	    if (key == 'mpr2' && val.val) {
		JQ('#l_bawe_net2').text('Einmalige Nettoprämie Bauwesenversicherung (Mindestprämie!):');
	    } else if (key == 'mpr2') {
		JQ('#l_bawe_net2').text('Einmalige Nettoprämie Bauwesenversicherung:');
	    }
	    if (key == 'brt2' && val.str) {
		ALL.chgProduct('bawe', val.str);
	    }
	});
	ALL.notifyHeight();
    },
};